export enum ApplicationState {
  Initializing,
  ReadyForAuthentication,
  FinishedInitializing,
}
